import { render, staticRenderFns } from "./aztecempire.vue?vue&type=template&id=5b0efd7d&scoped=true"
import script from "./aztecempire.vue?vue&type=script&lang=js"
export * from "./aztecempire.vue?vue&type=script&lang=js"
import style0 from "./aztecempire.vue?vue&type=style&index=0&id=5b0efd7d&prod&scoped=true&lang=css"
import style1 from "./aztecempire.vue?vue&type=style&index=1&id=5b0efd7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0efd7d",
  null
  
)

export default component.exports